import { render, staticRenderFns } from "./AdoptionChart.vue?vue&type=template&id=0a22fdef&"
import script from "./AdoptionChart.vue?vue&type=script&lang=js&"
export * from "./AdoptionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports